import Loading from "./Loding.vue"

export default {
  // 如果要将一个组件封装成一个插件，那么必须要有一个install方法
  //必须在instal方法中注册当前的这个组件

  install: function(Vue, options) {
    //1、根据我们的组件生成一个构造函数
    let LoadingContructor = Vue.extend(Loading);
    //2、根据构造函数创建实例对象
    let LoadingInstance = new LoadingContructor();
    //3、随便创建一个标签元素
    let Div = document.createElement("div");
    //4、将创建好的标签元素添加到界面上
    document.body.appendChild(Div);
    //5、将创建好的实例对象挂载到创建好的元素上
    LoadingInstance.$mount(Div);
    //6、修改组件中的属性
    if (options && options.title !== null && options.title !== undefined) {
      LoadingInstance.title = options.title
    }

    //7、添加全局方法
    Vue.showLoading = function() {
      LoadingInstance.isShow = true;
    }

    Vue.hideLoading = function() {
      LoadingInstance.isShow = false;
    }

    //8、添加实例方法
    Vue.prototype.$showLoading = function() {
      LoadingInstance.isShow = true;
    }

    Vue.prototype.$hideLoading = function() {
      LoadingInstance.isShow = false;
    }
  }
}